import React from 'react';
import { classnames, bem, use } from '../../lib';
export const DropzoneBox = ({ className, children, height, width, dashed }) => {
    return (React.createElement("div", { className: classnames(bem('dropzone__box', use(dashed, '--dashed')), className), style: { height, width } }, children));
};
//# sourceMappingURL=DropzoneBox.js.map